import styled from "styled-components";
import { useEffect, useState } from "react";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import goTo from "../../../../controllers/goTo";
import CustomButton from "../../../helperComponents/CustomButton";
import MiniProfileCard from "../MiniProfileCard";
import MaterialInput from "../../../helperComponents/MaterialInput";
import DropDownInput from "../../../helperComponents/DropDownInput";
import CustomCheckbox from "../../../helperComponents/CustomCheckbox";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import getUrlQuery from "../../../../controllers/getUrlQuery";
import ImagePicker from "../../../editors/ImagePicker";
import RolePermissionEditor from "./RolePermissionEditor";
import PermissionGuard from "../../../customUiForCs/PermissionGuard";
import { useTranslation } from "react-i18next";
import CustomLabel from "../../../customUiForCs/CustomLabel";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  /* margin-top: 100px; */
  align-items: center;
`;

const Inputs = styled.div`
  border-radius: 10px;
  display: flex;
  width: 700px;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  @media (max-width: 900px) {
    width: 90vw;
  }
`;

const InputItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  gap: 20px;
  width: 100%;
  border-radius: 20px;
  background-color: var(--surface2);
  border: 1px solid var(--border);
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 15px;
`;

const Buttons = styled.div`
  width: 38vw;
  /* background-color: red; */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
`;

let dropDownStyle = { flex: 1 };

const SubPermissions = styled.div`
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ExportGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export default function AddOrEditRole({}) {
  const { t } = useTranslation();
  const [itemID, setItemID] = useState(null);
  const [item, setItem] = useState(getItemWithDefaults({}));
  const [loading, setLoading] = useState(false);
  const [purpose, setPurpose] = useState("ADD");

  useEffect(() => {
    let newItemID = getUrlQuery("itemID");
    setItemID(newItemID);

    if (newItemID) setPurpose("UPDATE");
  }, []);

  useEffect(() => {
    if (purpose == "UPDATE") {
      setLoading(true);
      if (itemID) {
        loadItemToBeEdited();
      }
    }
  }, [itemID]);

  let titleLine1 = "Ajouter Un";
  let titleLine2 = "Nouveau Rôle";

  if (purpose == "UPDATE") {
    titleLine1 = "Modifier";
    titleLine2 = "Le Rôle";
  }

  let coreContent = <LoadingSection />;

  if (!loading) {
    coreContent = (
      <Container>
        {/* {getItemBeingEditedCard()} */}
        <Inputs>
          <InputItems>
            <MaterialInput
              label={"Nom du rôle"}
              value={item.name}
              onChange={updateField("name")}
            />
            <MaterialInput
              label={"Description"}
              value={item.description}
              onChange={updateField("description")}
              multiline={true}
              rows={2}
            />

            <RolePermissionEditor
              label="Personnel"
              value={item.profilePermissions}
              onChange={updateField("profilePermissions", true)}
            />

            <SubPermissions>
              <RolePermissionEditor
                label="Genre"
                value={item.genderPermissions}
                onChange={updateField("genderPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Identité"
                value={item.namePermissions}
                onChange={updateField("namePermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Fonction"
                value={item.employeeResponsibilityPermissions}
                onChange={updateField(
                  "employeeResponsibilityPermissions",
                  true
                )}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Type de contrat"
                value={item.contractTypePermissions}
                onChange={updateField("contractTypePermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Début du contrat"
                value={item.hiringDatePermissions}
                onChange={updateField("hiringDatePermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Site"
                value={item.siteIdPermissions}
                onChange={updateField("siteIdPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Date de naissance"
                value={item.dateOfBirthPermissions}
                onChange={updateField("dateOfBirthPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Numéro de téléphone"
                value={item.phoneNumberPermissions}
                onChange={updateField("phoneNumberPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Matricule"
                value={item.registrationNumberPermissions}
                onChange={updateField("registrationNumberPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Numéro CNPS"
                value={item.cnpsNumberPermissions}
                onChange={updateField("cnpsNumberPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Salaire"
                value={item.baseSalaryPermissions}
                onChange={updateField("baseSalaryPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Prime"
                value={item.primePermissions}
                onChange={updateField("primePermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Shift"
                value={item.shiftPermissions}
                onChange={updateField("shiftPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />

              <RolePermissionEditor
                label="Jour de repos"
                value={item.dayOfRestPermissions}
                onChange={updateField("dayOfRestPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />

              <RolePermissionEditor
                label="Nationalité"
                value={item.nationalityPermissions}
                onChange={updateField("nationalityPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />

              <RolePermissionEditor
                label="Statut Matrimonial"
                value={item.marriageStatusPermissions}
                onChange={updateField("marriageStatusPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />

              <RolePermissionEditor
                label="Nombre d'enfants"
                value={item.numberOfChildrenPermissions}
                onChange={updateField("numberOfChildrenPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />

              <RolePermissionEditor
                label="Badge"
                value={item.hasBadgePermissions}
                onChange={updateField("hasBadgePermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Assuré"
                value={item.isInsuredPermissions}
                onChange={updateField("isInsuredPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Type Virement"
                value={item.paymentTypePermissions}
                onChange={updateField("paymentTypePermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />

              <RolePermissionEditor
                label="fin de contrat"
                value={item.contractEndDatePermissions}
                onChange={updateField("contractEndDatePermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />

              <RolePermissionEditor
                label="Date de fin"
                value={item.departDatePermissions}
                onChange={updateField("departDatePermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />

              <RolePermissionEditor
                label="Actif"
                value={item.isActivePermissions}
                onChange={updateField("isActivePermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Email"
                value={item.emailPermissions}
                onChange={updateField("emailPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
              <RolePermissionEditor
                label="Role"
                value={item.roleIdPermissions}
                onChange={updateField("roleIdPermissions", true)}
                hideCreate={true}
                hideDelete={true}
              />
            </SubPermissions>

            <RolePermissionEditor
              label="Zones"
              value={item.zonePermissions}
              onChange={updateField("zonePermissions", true)}
            />

            <RolePermissionEditor
              label="Sites"
              value={item.sitePermissions}
              onChange={updateField("sitePermissions", true)}
            />

            <RolePermissionEditor
              label="Roles"
              value={item.rolePermissions}
              onChange={updateField("rolePermissions", true)}
            />

            <RolePermissionEditor
              label="Commentaires"
              value={item.commentPermissions}
              onChange={updateField("commentPermissions", true)}
            />

            <RolePermissionEditor
              label="Absences"
              value={item.absencePermissions}
              onChange={updateField("absencePermissions", true)}
            />

            <RolePermissionEditor
              label="Contentieux"
              value={item.disputePermissions}
              onChange={updateField("disputePermissions", true)}
            />

            <RolePermissionEditor
              label="Conges"
              value={item.vacationPermissions}
              onChange={updateField("vacationPermissions", true)}
            />

            <RolePermissionEditor
              label="Nomenclature"
              value={item.nomenclaturePermissions}
              onChange={updateField("nomenclaturePermissions", true)}
            />

            <RolePermissionEditor
              label="Pointage"
              value={item.dailyResponsibilityPermissions}
              onChange={updateField("dailyResponsibilityPermissions", true)}
            />

            <RolePermissionEditor
              label="Liste de présence"
              value={item.presenceListPermissions}
              onChange={updateField("presenceListPermissions", true)}
            />

            <SubPermissions>
              <CustomLabel>Exports</CustomLabel>
              <ExportGrid>
              <RolePermissionEditor
                label="Export Employés"
                value={item.employeeExportPermissions}
                onChange={updateField("employeeExportPermissions", true)}
                hideCreate={true}
                hideDelete={true}
                hideUpdate={true}
                hidePatch={true}
              />
              <RolePermissionEditor
                label="Export Absences"
                value={item.employeeExportAbsencePermissions}
                onChange={updateField("employeeExportAbsencePermissions", true)}
                hideCreate={true}
                hideDelete={true}
                hideUpdate={true}
                hidePatch={true}
              />
              <RolePermissionEditor
                label="Export Contentieux"
                value={item.employeeExportDisputePermissions}
                onChange={updateField("employeeExportDisputePermissions", true)}
                hideCreate={true}
                hideDelete={true}
                hideUpdate={true}
                hidePatch={true}
              />
              <RolePermissionEditor
                label="Export Congés"
                value={item.employeeExportVacationPermissions}
                onChange={updateField("employeeExportVacationPermissions", true)}
                hideCreate={true}
                hideDelete={true}
                hideUpdate={true}
                hidePatch={true}
              />
              <RolePermissionEditor
                label="Export Inactifs"
                value={item.employeeExportInactivePermissions}
                onChange={updateField("employeeExportInactivePermissions", true)}
                hideCreate={true}
                hideDelete={true}
                hideUpdate={true}
                hidePatch={true}
              />
              <RolePermissionEditor
                label="Export Sites"
                value={item.siteExportPermissions}
                onChange={updateField("siteExportPermissions", true)}
                hideCreate={true}
                hideDelete={true}
                hideUpdate={true}
                hidePatch={true}
              />
              <RolePermissionEditor
                label="Export Contrats (Sites)"
                value={item.siteExportContractPermissions}
                onChange={updateField("siteExportContractPermissions", true)}
                hideCreate={true}
                hideDelete={true}
                hideUpdate={true}
                hidePatch={true}
              />
              <RolePermissionEditor
                label="Export Assistance (Sites)"
                value={item.siteExportAssistancePermissions}
                onChange={updateField("siteExportAssistancePermissions", true)}
                hideCreate={true}
                hideDelete={true}
                hideUpdate={true}
                hidePatch={true}
              />
              </ExportGrid>
            </SubPermissions>

            <RolePermissionEditor
              label="Activities"
              value={item.activitiesPermissions}
              onChange={updateField("activitiesPermissions", true)}
            />

            <RolePermissionEditor
              label="Tableau de bord"
              value={item.dashboardPermissions}
              onChange={updateField("dashboardPermissions", true)}
            />
          </InputItems>
          <br />
          <Buttons>
            <CustomButton style={{ padding: "15px 40px" }} onClick={save}>
              {purpose == "UPDATE"
                ? "Modifier le rôle"
                : "Ajouter un nouveau rôle"}
            </CustomButton>
          </Buttons>
        </Inputs>
      </Container>
    );
  }

  // Ensure export permission arrays are always defined, otherwise they get dropped on save
  function getItemWithDefaults(raw) {
    const defaults = {
      employeeExportPermissions: [],
      employeeExportAbsencePermissions: [],
      employeeExportDisputePermissions: [],
      employeeExportVacationPermissions: [],
      employeeExportInactivePermissions: [],
      siteExportPermissions: [],
      siteExportContractPermissions: [],
      siteExportAssistancePermissions: [],
    };
    return { ...defaults, ...raw };
  }

  return (
    <PermissionGuard
      permissionName={"rolePermissions"}
      action={purpose == "ADD" ? "CREATE" : "UPDATE"}
    >
      <LoggedInBoilerplate
        showBackButton={true}
        titleLine1={titleLine1}
        titleLine2={titleLine2}
      >
        {coreContent}
      </LoggedInBoilerplate>
    </PermissionGuard>
  );

  function updateField(fieldName, dontUseEventValue) {
    return (e) => {
      let newItem = { ...item };
      if (dontUseEventValue) {
        newItem[fieldName] = e;
      } else {
        newItem[fieldName] = e.target.value;
      }

      setItem(newItem);
    };
  }

  // function getItemBeingEditedCard() {
  //   if (purpose !== "UPDATE") return;
  //   return (
  //     <MiniProfileCard item={item} onClick={goTo(`/employee/${itemID}`)} />
  //   );
  // }

  function save() {
    if (purpose == "UPDATE") editItem();
    if (purpose == "ADD") createItem();
  }

  async function loadItemToBeEdited() {
    let data = await serverLine.get(`/role/?itemID=${itemID}`);

    setItem(getItemWithDefaults(data));
    setLoading(false);
  }

  async function createItem() {
    setLoading(true);

    try {
      let res = await serverLine.post("/role", {
        name: item.name,
        description: item.description,
        registrationNumberPermissions: item.registrationNumberPermissions,
        profilePermissions: item.profilePermissions,
        sitePermissions: item.sitePermissions,
        rolePermissions: item.rolePermissions,
        commentPermissions: item.commentPermissions,
        zonePermissions: item.zonePermissions,
        absencePermissions: item.absencePermissions,
        disputePermissions: item.disputePermissions,
        vacationPermissions: item.vacationPermissions,
        searchableText: item.searchableText,
        nomenclaturePermissions: item.nomenclaturePermissions,
        dailyResponsibilityPermissions: item.dailyResponsibilityPermissions,
        presenceListPermissions: item.presenceListPermissions,
        activitiesPermissions: item.activitiesPermissions,
        dashboardPermissions: item.dashboardPermissions,
        employeeExportPermissions: item.employeeExportPermissions,
        employeeExportAbsencePermissions: item.employeeExportAbsencePermissions,
        employeeExportDisputePermissions: item.employeeExportDisputePermissions,
        employeeExportVacationPermissions: item.employeeExportVacationPermissions,
        employeeExportInactivePermissions: item.employeeExportInactivePermissions,
        siteExportPermissions: item.siteExportPermissions,
        siteExportContractPermissions: item.siteExportContractPermissions,
        siteExportAssistancePermissions: item.siteExportAssistancePermissions,
        genderPermissions: item.genderPermissions,
        namePermissions: item.namePermissions,
        employeeResponsibilityPermissions:
          item.employeeResponsibilityPermissions,
        contractTypePermissions: item.contractTypePermissions,
        hiringDatePermissions: item.hiringDatePermissions,
        siteIdPermissions: item.siteIdPermissions,
        dateOfBirthPermissions: item.dateOfBirthPermissions,
        phoneNumberPermissions: item.phoneNumberPermissions,
        cnpsNumberPermissions: item.cnpsNumberPermissions,
        baseSalaryPermissions: item.baseSalaryPermissions,
        primePermissions: item.primePermissions,
        shiftPermissions: item.shiftPermissions,
        dayOfRestPermissions: item.dayOfRestPermissions,
        hasBadgePermissions: item.hasBadgePermissions,
        isInsuredPermissions: item.isInsuredPermissions,
        paymentTypePermissions: item.paymentTypePermissions,
        contractEndDatePermissions: item.contractEndDatePermissions,
        departDatePermissions: item.departDatePermissions,
        isActivePermissions: item.isActivePermissions,
        emailPermissions: item.emailPermissions,
        roleIdPermissions: item.roleIdPermissions,
        //
        nationalityPermissions: item.nationalityPermissions,
        numberOfChildrenPermissions: item.numberOfChildrenPermissions,
        marriageStatusPermissions: item.marriageStatusPermissions,
      });

      goTo(`/role/${res._id}`)();
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }

  async function editItem() {
    setLoading(true);

    let changes = {
      name: item.name,
      description: item.description,
      registrationNumberPermissions: item.registrationNumberPermissions,
      profilePermissions: item.profilePermissions,
      sitePermissions: item.sitePermissions,
      rolePermissions: item.rolePermissions,
      commentPermissions: item.commentPermissions,
      zonePermissions: item.zonePermissions,
      absencePermissions: item.absencePermissions,
      disputePermissions: item.disputePermissions,
      vacationPermissions: item.vacationPermissions,
      searchableText: item.searchableText,
      nomenclaturePermissions: item.nomenclaturePermissions,
      dailyResponsibilityPermissions: item.dailyResponsibilityPermissions,
      presenceListPermissions: item.presenceListPermissions,
      activitiesPermissions: item.activitiesPermissions,
      dashboardPermissions: item.dashboardPermissions,
      employeeExportPermissions: item.employeeExportPermissions,
      employeeExportAbsencePermissions: item.employeeExportAbsencePermissions,
      employeeExportDisputePermissions: item.employeeExportDisputePermissions,
      employeeExportVacationPermissions: item.employeeExportVacationPermissions,
      employeeExportInactivePermissions: item.employeeExportInactivePermissions,
      siteExportPermissions: item.siteExportPermissions,
      siteExportContractPermissions: item.siteExportContractPermissions,
      siteExportAssistancePermissions: item.siteExportAssistancePermissions,
      genderPermissions: item.genderPermissions,
      namePermissions: item.namePermissions,
      employeeResponsibilityPermissions: item.employeeResponsibilityPermissions,
      contractTypePermissions: item.contractTypePermissions,
      hiringDatePermissions: item.hiringDatePermissions,
      siteIdPermissions: item.siteIdPermissions,
      dateOfBirthPermissions: item.dateOfBirthPermissions,
      phoneNumberPermissions: item.phoneNumberPermissions,
      cnpsNumberPermissions: item.cnpsNumberPermissions,
      baseSalaryPermissions: item.baseSalaryPermissions,
      primePermissions: item.primePermissions,
      shiftPermissions: item.shiftPermissions,
      dayOfRestPermissions: item.dayOfRestPermissions,
      hasBadgePermissions: item.hasBadgePermissions,
      isInsuredPermissions: item.isInsuredPermissions,
      paymentTypePermissions: item.paymentTypePermissions,
      contractEndDatePermissions: item.contractEndDatePermissions,
      departDatePermissions: item.departDatePermissions,
      isActivePermissions: item.isActivePermissions,
      emailPermissions: item.emailPermissions,
      roleIdPermissions: item.roleIdPermissions,
      //
      nationalityPermissions: item.nationalityPermissions,
      numberOfChildrenPermissions: item.numberOfChildrenPermissions,
      marriageStatusPermissions: item.marriageStatusPermissions,
    };

    console.log(changes);

    try {
      let res = await serverLine.patch("/role", {
        itemID,
        changes,
      });

      window.popupAlert(t("done"));
      // goTo(`/role/${res._id}`)();
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }
}
